<template>
  <div class="main-features py-6 m:py-8 l:py-12">
    <div class="main-features__container container">
      <div class="grid">
        <h2 class="main-features__headline grid__el--xs-12">
          {{ headline }}
        </h2>
      </div>

      <div class="main-features__features grid">
        <div
          class="main-features__feature grid__el--xs-12 grid__el--m-4"
          v-for="feature in $t('features')"
          :key="feature.headline">
          <main-feature :feature="feature" />
        </div>
      </div>
      <start-trial-button-with-pricing
        event-category="body-20210610-main_features"
        :signup-route="signupRoute"
        :show-trial-end-date="showTrialEndDate"
        v-if="signupRoute" />
    </div>
  </div>
</template>

<script>
import MainFeature from "@/pages/book/components/main-feature";
import StartTrialButtonWithPricing  from "@/shared/start-trial-button-with-pricing";

export default {
  name: "MainFeatures",
  components: {
    MainFeature,
    StartTrialButtonWithPricing
  },
  props: {
    signupRoute: {
      type: String,
      required: false,
      default: null
    },
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    headlineVariation: {
      type: String,
      default: "headline"
    }
  },
  computed: {
    headline() {
      return this.$t(this.headlineVariation);
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "More knowledge in less time",
        xDayChallenge: "Blinkist brings you",
        variationHeadline: "Understand books & podcasts in 15 minutes",
        trialInfo: "Cancel anytime before {trialEndDate} and you won’t ever be charged.",
        features: [
          {
            headline: "Read or listen",
            subheadline: "Get the key ideas from nonfiction bestsellers in minutes, not hours.",
            icon: "headphones"
          },
          {
            headline: "Find your next read",
            subheadline: "Get book lists curated by experts and personalized recommendations.",
            icon: "bulb"
          },
          {
            headline: "Shortcasts",
            subheadline: "We’ve teamed up with podcast creators to bring you key insights from podcasts.",
            icon: "mic",
            new: "NEW"
          }
        ]
      },
      de: {
        headline: "Mehr Wissen in weniger Zeit",
        variationHeadline: "Mehr Wissen in weniger Zeit",
        trialInfo: "Testen kostet nichts: Kündige einfach vor dem {trialEndDate} und dir entstehen keine Kosten.",
        features: [
          {
            headline: "Sachbücher auf den Punkt gebracht",
            subheadline: "Kernaussagen aus Sachbüchern in ca. 15 Minuten pro Titel lesen & anhören mit den „Blinks”",
            icon: "headphones"
          },
          {
            headline: "Zeitsparende Empfehlungen",
            subheadline: "Titel, die dein Leben bereichern, passend zu deinen Interessen und Zielen",
            icon: "bulb"
          },
          {
            headline: "Podcasts in Kurzform",
            subheadline: "Kernaussagen wichtiger Podcasts im Kurzformat mit den neuen „Shortcasts”",
            icon: "mic",
            new: "NEU"
          }
        ]
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-features {

  &__headline {
    @include font-style((xs: h3, m: h2));

    text-align: center;
  }

  &__features {
    margin-bottom: $spacing-32;

    @include media(min-width, m) {
      margin-bottom: $spacing-48;
    }
  }

  &__feature {

    &:not(:last-child) {
      margin-bottom: $spacing-24;
    }
  }
}
</style>
